import { render, staticRenderFns } from "./manualRefundAl.vue?vue&type=template&id=3bc29f10&scoped=true"
import script from "./manualRefundAl.vue?vue&type=script&lang=js"
export * from "./manualRefundAl.vue?vue&type=script&lang=js"
import style0 from "./manualRefundAl.vue?vue&type=style&index=0&id=3bc29f10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc29f10",
  null
  
)

export default component.exports